import ShiftDetailsTable from './ShiftDetailsTable'
export default ShiftDetailsTable